import React from 'react';
import { Calendar, UserCheck, Wrench, Droplets } from 'lucide-react';

const defaultSteps = [
  { icon: Calendar, title: 'Book Online', desc: 'Schedule via call, WhatsApp or website' },
  { icon: UserCheck, title: 'Expert Visits', desc: 'Certified technician at your doorstep' },
  { icon: Wrench, title: 'Service Done', desc: 'Installation, repair or maintenance' },
  { icon: Droplets, title: 'Pure Water', desc: 'Enjoy clean, healthy water daily' },
];

const HowItWorks = ({ cms }) => {
  const d = cms || {};
  const title = d.title || 'How It Works';
  const subtitle = d.subtitle || 'Simple Process';
  const cmsSteps = d.items || d.steps;

  const displaySteps = cmsSteps && cmsSteps.length > 0
    ? cmsSteps.map((item, i) => ({
        icon: defaultSteps[i]?.icon || Calendar,
        title: item.title || defaultSteps[i]?.title || `Step ${i + 1}`,
        desc: item.description || item.desc || defaultSteps[i]?.desc || '',
      }))
    : defaultSteps;

  return (
  <section className="py-16 md:py-24 bg-white reveal-on-scroll" data-testid="how-it-works-section">
    <div className="container mx-auto px-4">
      <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
        <p className="text-xs sm:text-sm font-semibold text-blue-700 uppercase tracking-wider mb-3">{subtitle}</p>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
          {title.includes('Works') ? <>How It <span className="text-blue-700">Works</span></> : title}
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 max-w-4xl mx-auto">
        {displaySteps.map((step, i) => (
          <div key={i} className="text-center relative step-connector" data-testid={`step-${i}`}>
            <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-3 sm:mb-4 rounded-2xl bg-blue-50 border border-blue-100 flex items-center justify-center relative z-10">
              <step.icon className="text-blue-700" size={24} />
            </div>
            <div className="text-[10px] sm:text-xs font-bold text-lime-600 uppercase tracking-wider mb-1">Step {i + 1}</div>
            <h3 className="text-xs sm:text-sm md:text-base font-bold text-gray-900 mb-0.5 sm:mb-1">{step.title}</h3>
            <p className="text-[10px] sm:text-xs md:text-sm text-gray-500">{step.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};

export default HowItWorks;
